<div mat-dialog-header class="title">
  Export Data
</div>
<div mat-dialog-content>
  <div *ngIf="!isLoading" class="flex-row">
    <div class="icon-box" (click)="reportExport()">
      <mat-icon svgIcon="pdf"></mat-icon>
      <span>Get Report</span>
    </div>
    <a *ngIf="token$|async" target="api" [href]="apiUrl$|async">
      <div class="icon-box">
        <mat-icon style="color:#707FFF">api</mat-icon>
        <span>Get API</span>
      </div>
    </a>
    <div class="icon-box" [ngClass]="{active: showMonthlyCsvMonths}" (click)="openCSVDialog()">
      <mat-icon svgIcon="csv"></mat-icon>
      <span>Get CSV</span>
    </div>
  </div>
  <div *ngIf="!isLoading && showMonthlyCsvMonths" class="mt-15">
    <mat-form-field class="full-width">
      <mat-label>Select Month</mat-label>
      <mat-select [(value)]="selectedMonthlyCsvMonth">
        <mat-option *ngFor="let month of monthlyCsvMonths" [value]="month.month" [disabled]="month.status !== 'ready'">
          {{ month.label }}{{ month.status !== 'ready' ? ' - ' + month.status : '' }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div *ngIf="hasCurrentMonthCsv" class="monthly-csv-hint">
      Current month data is available up to last Friday.
    </div>
    <div *ngIf="monthlyCsvMonths.length === 0" class="container centered-content">
      No monthly CSV reports are ready.
    </div>
  </div>
  <div *ngIf="isLoading" class="container centered-content">
    <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
  </div>
  <div mat-dialog-actions class="footer">
    <button mat-button (click)="cancel()">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      *ngIf="showMonthlyCsvMonths"
      [disabled]="!selectedMonthlyCsvMonth || isLoading"
      (click)="downloadMonthlyCsv(selectedMonthlyCsvMonth)">
      Download
    </button>
  </div>
</div>
